import * as tslib_1 from "tslib";
// PO31
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import Flex from '../../Flex';
import IconPlay from '../../Icons/Play';
import { IconSize } from '../../Icons/IconWrap';
import Logo from '../../Logo';
import Popup from '../../Popup';
import VideoPopup from '../Video';
import { FirstTimeFlag, } from '../../redux/firstTimeFlags';
import reduxContainer from './Eclipse.container';
import s from './Eclipse.scss';
var defaultState = {
    showVideoPopup: false,
};
var enhance = compose(reduxContainer, withTranslation());
var Eclipse = /** @class */ (function (_super) {
    tslib_1.__extends(Eclipse, _super);
    function Eclipse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = defaultState;
        _this.dropFirstTimeFlag = function () {
            if (!_this.props.dropFirstTimeFlag) {
                return;
            }
            _this.props.dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed,
            });
        };
        _this.dropFirstTimeFlagAndNavigateToBrowse = function () {
            if (!_this.props.dropFirstTimeFlag) {
                return;
            }
            _this.props.dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed,
                redirectTo: Url.browseHomeLink(),
            });
        };
        _this.showVideoPopup = function () {
            _this.setState({ showVideoPopup: true });
        };
        _this.hideVideoPopup = function () {
            _this.setState({ showVideoPopup: false });
        };
        return _this;
    }
    Eclipse.prototype.render = function () {
        if (this.state.showVideoPopup) {
            return this.renderVideoPopup();
        }
        return this.renderMainPopup();
    };
    Eclipse.prototype.renderMainPopup = function () {
        var _a = this.props, t = _a.t, title = _a.title, subtitle = _a.subtitle, text = _a.text, note = _a.note;
        return (React.createElement(Popup, { isOpen: true, onRequestClose: this.dropFirstTimeFlag, className: s['popup'] },
            React.createElement(Flex, { direction: "row", className: classnames(s['root'], !note && s['root-shrink'], this.props.className) },
                React.createElement(Flex, { direction: "column", justifyContent: "space-between", className: s['left-column'] },
                    React.createElement(Logo, { className: s['logo'], size: "tiny", markColor: "white", textColor: "white" }),
                    React.createElement(Flex, { direction: "column" },
                        React.createElement("div", { className: s['title'] }, title),
                        subtitle && React.createElement("div", { className: s['subtitle'] }, subtitle))),
                React.createElement(Flex, { direction: "column", className: s['right-column'] },
                    React.createElement("div", { className: s['right-column-top'] },
                        React.createElement("div", { className: s['text'] }, text),
                        React.createElement("div", null,
                            React.createElement("div", { className: s['video-title'] }, t('welcomePopup.video.title')),
                            React.createElement("a", { className: s['button-play'], onClick: this.showVideoPopup },
                                React.createElement(Flex, { className: s['video'], justifyContent: "center", alignItems: "center" },
                                    React.createElement(IconPlay, { className: s['icon-play'], size: IconSize.MEGA }))))),
                    React.createElement(Flex, { direction: "column", justifyContent: "center", className: s['right-column-bottom'] },
                        React.createElement(Flex, { direction: "column", justifyContent: "space-between" }, note && (React.createElement("div", { className: s['right-column-bottom-note'] }, note))))))));
    };
    Eclipse.prototype.renderVideoPopup = function () {
        return (React.createElement(VideoPopup, { onRequestClose: this.hideVideoPopup, source: "//film00.deviantart.net/0ed2/v/mp4/2019/070/5/5/master_browser_da_yt_small4_by_team-dd1wrm9.mp4", posterFrame: "//st.deviantart.net/eclipse/popups/welcome/black_ocean_by_macrebisz.jpg", autoPlay: true }));
    };
    return Eclipse;
}(React.Component));
export { Eclipse };
export default enhance(Eclipse);
//# sourceMappingURL=Eclipse.js.map